<template>
    <div class="side-box">
        <h1>{{notifyStaffChat.id}}</h1>
        <v-layout justify-space-between align-center class="side-box-header">
            <div class="side-box-title">{{$t('supporterList')}}</div>
            <v-icon @click="toggleStaffChat">mdi-close</v-icon>
        </v-layout>
        <div class="side-box-content">
            <div class="search-view">
                <div class="search-staff">
                    <input
                        v-model="searchStaffKey"
                        type="text"
                        autocomplete="none"
                        :placeholder="$t('enterNameOrEmail')"
                        ref="search">
                </div>
                <div v-if="staffList.length < 2" class="pa-3" style="text-align: center;color: #B5B5B5;">
                    {{$t('emptySupporterMessage')}}
                </div>
                <div
                        v-for="(staff,i) in staffListFilter"
                        :key="i"
                        class="staff-item"
                        :class="{active: staff.id === activeStaff.id}"
                        @click="openChatView(staff)"
                >
                    <v-layout align-center>
                        <div style="margin-right: 12px">
                            <v-badge :value="countNotification(staff) > 0" overlap color="#FF5F5F">
                                <template v-slot:badge>
                                    {{countNotification(staff)}}
                                </template>
                                <img v-if="staff.image" :src="staff.image" alt="icon" class="staff-image">
                                <div v-else class="staff-icon">
                                    {{$AppService.createTextImage(staff.name ? staff.name : staff.email.split('@')[0])}}
                                </div>
                            </v-badge>
                        </div>
                        <div>
                            <span class="staff-name" :class="{bold: countNotification(staff) > 0}">
                                {{staff.name ? staff.name : staff.email.split('@')[0]}}
                            </span><br>
                            <span class="staff-email" :class="{bold: countNotification(staff) > 0}">
                                {{staff.email}}
                            </span>
                        </div>
                        <v-spacer></v-spacer>
                        <div v-if="activeStaff && staff.id === activeStaff.id">
                            <v-icon small>mdi-check-circle</v-icon>
                        </div>
                    </v-layout>
                </div>
            </div>
            <div class="chatview" v-if="showChatView">
                <v-layout align-center class="chatview-header">
                    <img src="/icon/message.svg" alt="icon" style="margin-right: 6px">
                    <div>
                        {{activeStaff.name}}
                        <span class="staff-email">({{activeStaff.email}})</span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-icon @click="hideChatView" color="#fff">mdi-close</v-icon>
                </v-layout>
                <div class="chatview-content" ref="content">
                    <div v-for="(log, i) of chatLog" :key="i" :id="log.id">
                        <div class="content-row" :class="log.isMe ? 'right' : 'left'">
                            <div v-if="!log.isMe">
                                <img
                                        v-if="log.sender.image"
                                        :src="log.sender.image"
                                        alt="user-icon"
                                        class="content-icon">
                                <div v-else class="text-icon">
                                    {{$AppService.createTextImage(log.sender.name)}}
                                </div>
                            </div>
                            <div class="content-wrapper" v-html="log.content" v-linkified>
                            </div>
                        </div>
                    </div>
                </div>
                <v-layout class="chatview-footer" align-center>
                    <v-form @submit.prevent="submit" style="width: 100%">
                        <v-layout align-center>
                            <input v-model="message" class="ma-1 pl-1" :placeholder="$t('typeMessage')" ref="input"/>
                            <button class="ml-1 mr-3 pr-1" type="submit">
                                <v-icon color="#B2B4C6">mdi-send</v-icon>
                            </button>
                        </v-layout>
                    </v-form>
                </v-layout>
            </div>
        </div>
    </div>
</template>
<script>
import StaffService from "@/services/staff.service";
import {mapMutations, mapState} from 'vuex';
import _ from 'lodash';

export default {
    name: "StaffChat",
    data () {
        return {
            message: '',
            chatLog: [],
            showChatView: false,
            searchStaffKey: '',
            me: StaffService.getMe() ? StaffService.getMe() : null,
            myToken: StaffService.getJwt() ? StaffService.getJwt() : '',
            channel: 'private',
            lastChatLogId: null,
            shouldLoadMoreChatLogs: true,
            shouldBindLoadChatLogEvent: true,
            isFirstLoadChatLog: true,
            scrollLoadChatLog: null,
            channelSubscription: null
        }
    },
    computed: {
        staffListFilter () {
            let list = this.staffList;
            let key = this.searchStaffKey.trim().toLowerCase();
            if (key) {
                list = _.filter(
                    this.staffList,
                    item => item.name.toLowerCase().includes(key) || item.email.toLowerCase().includes(key)
                )
            }
            list = _.filter(list, item => item.id !== this.me.id);
            return list
        },
        ...mapState(['activeStaff', 'staffList', 'showStaffChat','notifyStaffChat']),
    },
    created () {
        this.$EventBus.$on(this.$EventBusType.TOGGLE_STAFF_CHAT, this.focusInput);
    },
    destroyed () {
        this.$EventBus.$off(this.$EventBusType.TOGGLE_STAFF_CHAT, this.focusInput);
    },
    methods: {
        ...mapMutations('sideBox', ['toggleStaffChat']),
        focusInput () {
            if (this.showStaffChat) {
                this.$nextTick(() => {
                    if (this.showChatView) {
                        this.$refs.input.focus();
                    } else {
                        this.$refs.search.focus();
                    }
                })
            }
        },
        openChatView (staff) {
            if (staff.id !== this.activeStaff.id) {
                if (this.channelSubscription) {
                    this.channelSubscription.destroy();
                }
                this.showChatView = true;
                this.isFirstLoadChatLog = true;
                this.shouldLoadMoreChatLogs = true;
                this.lastChatLogId = null;
                this.chatLog = [];
                this.$store.commit(this.$ActionTypes.ACTIVE_STAFF, staff);
                this.$nextTick(() => {
                    this.loadChatLog();
                    this.connectSocket();
                    this.$refs.input.focus();
                });
            }
        },
        submit () {
            let message = this.message.trim();
            if (message) {
                StaffService.sendMessage(this.myToken, this.me.id, this.activeStaff.id, 'text', message)
            }
            this.message = ""
        },
        loadChatLog () {
            if (this.shouldBindLoadChatLogEvent) {
                this.shouldBindLoadChatLogEvent = false;
                let element = this.$refs.content;
                element.addEventListener('scroll', () => {
                    if (!this.isFirstLoadChatLog && element.scrollTop === 0) {
                        this.loadChatLog()
                    }
                })
            }
            if (this.shouldLoadMoreChatLogs) {
                StaffService.getChatLogs(this.me.id, this.activeStaff.id, this.lastChatLogId).then(
                    result => {
                        if (result.data.chatlog.length > 0) {
                            this.shouldLoadMoreChatLogs = !!result.data.next;
                            this.lastChatLogId = result.data.chatlog[result.data.chatlog.length - 1]._id;
                            let chatLog = [];
                            let rawLog = _.orderBy(result.data.chatlog, item => item.created_time);
                            for (let log of rawLog) {
                                chatLog.push({
                                    id: log._id,
                                    isMe: log.user_id === this.me.id,
                                    content: JSON.parse(log.message).text,
                                    time: this.$filters.formatTime(log.created_time),
                                    sender: {
                                        id: log.user_id,
                                        email: log.user_email,
                                        name: log.user_name,
                                    }
                                })
                            }
                            let element = this.$refs.content;
                            if (this.isFirstLoadChatLog) {
                                this.isFirstLoadChatLog = false;
                                this.chatLog = chatLog;
                                this.$nextTick(() => {
                                    element.scrollTop = element.scrollHeight - element.clientHeight;
                                });
                            } else {
                                let id = this.chatLog[0].id;
                                this.chatLog = [...chatLog, ...this.chatLog];
                                element.scrollTop = document.getElementById(id).offsetTop;
                            }
                        }
                    },
                    () => {
                        this.chatLog = []
                    }
                );
            }
        },
        connectSocket () {
            if (this.$store.state.scClient) {
                // check subscribed > unsubscribe
                if (this.channelSubscription && this.channelSubscription.state && this.channelSubscription.state === 'subscribed') {
                    this.channelSubscription.destroy();
                }

                this.channelSubscription = StaffService.startConversation(this.me.id, this.activeStaff.id);
                if (this.channelSubscription) {
                    this.channelSubscription.watch(data => {
                        this.chatLog.push({
                            isMe: data.from_uid === this.me.id,
                            content: data.message.text,
                            time: '12:12',
                            sender: StaffService.getStaffById(data.from_uid)
                        });
                        this.$nextTick(() => {
                            let element = this.$refs.content;
                            element.scrollTop = element.scrollHeight - element.clientHeight
                        })
                    });
                }
            }
        },
        hideChatView () {
            this.showChatView = false;
            this.$store.commit(this.$ActionTypes.ACTIVE_STAFF, {});
            this.shouldBindLoadChatLogEvent = true;
        },
        countNotification (staff) {
            return this.notifyStaffChat[staff.id]
        }
    },
}
</script>
<style scoped lang="scss" src="@/components/style/side-box.scss"></style>
<style scoped lang="scss" src="@/components/style/staff.scss"></style>
<style scoped lang="scss" src="@/components/style/staff-chat.scss"></style>
